module.exports = __webpack_public_path__ + "static/media/boy-laptop_mobile.b140e4b9.png";